<template>
  <div class="mask" :class="{ maskActive: isOpenCartDialog }" @click="closeMobileCartDialog" />
  <transition name="slide-up">
    <div v-if="isOpenCartDialog" id="dialog-market" class="dialog-bottom dialog-item">
      <div class="dialog-mask mask" @click="closeMobileCartDialog" />
      <div class="dialog-bottom-content">
        <div class="item-info">
          <div class="btn-dialog-del" @click="closeMobileCartDialog">
            <i class="icon-close" />
          </div>
          <div class="info-block">
            <div class="text-block">
              <div class="item-name">
                {{ itemDatas.Name }}
              </div>
              <div class="item-price">
                <span class="sell-price">NT. {{ mapSellPrice.toLocaleString() }}</span>
                <span
                  v-if="itemDatas.SellPrice !== itemDatas.OriginPrice || itemDatas.EventPrice > 0"
                  class="origin-price"
                >
                  NT. {{ itemDatas.OriginPrice.toLocaleString() }}
                </span>
              </div>
              <div v-for="event in itemDatas.Events" :key="event.ID" class="event-text">
                <span>(活動) {{ event.Name }}</span>
              </div>

              <div v-if="selectedSpec !== null && selectedSpec.PreOrder" class="event-text">
                {{ itemDatas.ArrivalExplanation }}
              </div>
              <div class="product-color-wrap">
                <ul>
                  <li
                    v-for="color in itemDatas.Colors"
                    :key="color.ID"
                    class="product-color"
                    :class="{ active: color.ID === selectedData.ID }"
                    @click="changeImg(color.ID)"
                  >
                    <img class="m-0" :src="color.PintSizePictureUrl + '?w=20&h=20'" />
                  </li>
                </ul>
              </div>
            </div>
            <div class="dialog-item-img">
              <NewImage
                v-if="selectedData.Images?.length !== 0"
                :url="selectedProductImg[0]?.Url"
                :size="'_w364_h504'"
                :name="itemDatas.Name"
              />
            </div>
          </div>
          <div class="select-container">
            <div class="size-select">
              <Selector
                :options="selectedData.Specs"
                :default-txt="'尺寸'"
                :selected="selectedSpec"
                :is-mobile="isMobile"
                @cb="selectSpec"
              />
            </div>
            <div class="count-select">
              <Quantity
                v-model="counter"
                :default-txt="'數量'"
                :reduce-count="() => reduceCount()"
                :add-count="
                  () =>
                    addCount({
                      maxCount: selectedSpec.Stock,
                      limit: itemDatas.Limit,
                    })
                "
              />
            </div>
          </div>
          <div class="dialog-bottom-container">
            <button
              :class="btnStyleGenerate"
              class="btn dialog-bottom-btn"
              @click.prevent="clickToCart"
            >
              {{ btnDescriptionGenerate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue';

import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';

import useSetEnv from '@global/composable/useSetEnv';
import useMsg from '@global/composable/useMessage';
import useAlert from '@global/composable/useAlert';

import NewImage from '@global/components/common/Image/NewImage.vue';

import Selector from '@components/Select.vue';
import Quantity from '@components/Quantity.vue';

const { setEnv } = useSetEnv();
const { messageBox } = useMsg();
const { alertDialog } = useAlert();

const shopContentStore = useShopContentStore();
const isMobile = setEnv.myEquipment();

const {
  selectedData,
  itemDatas,
  selectedSpec,
  counter,
  isOpenCartDialog,
  btnStyleGenerate,
  btnDescriptionGenerate,
} = storeToRefs(shopContentStore);

const { addCount, reduceCount, closeMobileCartDialog, addToCart, selectSpec, changeImg } =
  shopContentStore;

const selectedProductImg = computed(() => {
  return selectedData.value.Images.filter((img) => img.Category === 0);
});

const mapSellPrice = computed(() => {
  return itemDatas.value.EventPrice > 0 && itemDatas.value.EventPrice < itemDatas.value.SellPrice
    ? itemDatas.value.EventPrice
    : itemDatas.value.SellPrice;
});

async function clickToCart() {
  try {
    const resolve = await addToCart();
    if (resolve === undefined) return;
    const { code } = resolve;

    switch (code) {
      case 200:
        messageBox.cart('加入購物車');
        break;
      case 205:
        alertDialog.alert('商品已售完', () => {
          window.location.reload();
        });
        break;
      default:
        break;
    }
  } catch (error) {
    console.log(error);
  }
}
</script>
